
import { useTranslation } from 'react-i18next'
import borderSrc from '../../assets/claimed-border.svg'
import styles from './Ban.module.scss'

export const BanScreen = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.frame}>
      <img
        src={borderSrc}
        alt=""
        className={styles.frameBorder}
        aria-hidden
      />

      <p className={styles.subtitle}>$NOT $NOT $NOT</p>
      <div className={styles.amount}>{t('rewards.ban')}</div>
      <span className={styles.comingSoon}>$NOT $NOT $NOT</span>
    </div>
  )
}
